import { useState } from 'react';
import styled from 'styled-components';
import moment from "moment";
// components
import { Toggle, TextInput, Button } from 'carbon-components-react';
import { Row, Col } from 'react-bootstrap'
import TrialIdModal from './TrialIdModal'

const DetailOverview = ({
  data,
  submit,
}) => {
  const [idModalIsOpen, setIdModalIsOpen] = useState(false)

  const onlyAttachment = localStorage.getItem('only_attachment')
  const formatUpdateDate = (date) => {
    if (!data) return null;
    return date ? moment(date).format("DD-MMM-YYYY, hh:mm:ss a") : "N/A";
  }

  /** EVENT HANDLERS */

  const onToggle = (value, id, evt) => {
    submit(id, value)
  }

  return (
    <div>

      <Row className="mb-0 mb-md-4" style={{ alignItems: 'flex-start' }}>
        <TrialIdColStyled className="col-12 col-md-5 mb-4 mb-md-0">
          <TrialIdFieldStyled>
            <TextInput
              id="org_study_id"
              labelText="Sponsor Trial ID"
              value={data?.org_study_id || "N/A"}
              size="sm"
              readOnly={true}
            />
          </TrialIdFieldStyled>&nbsp;
          { onlyAttachment !== "true" && 
            <Button
              size="small"
              onClick={() => setIdModalIsOpen(true)}
            >Edit</Button>
          }
        </TrialIdColStyled>

        <Col xs="12" md={{ span: 5, offset: 1 }} className="mb-4 mb-md-0">
          <TextFieldStyled>
            <TextInput
              id=""
              labelText="Study Updated on"
              value={formatUpdateDate(data?.updated_at)}
              size="sm"
              readOnly={true}
            />
          </TextFieldStyled>
        </Col>

      </Row>

      <Row className="mb-0 mb-md-4" style={{ alignItems: 'flex-start' }}>
        <Col xs="12" md="4" className="mb-4 mb-md-0">
          <Toggle
            id="has_results"
            labelA="Does Not Have Results"
            labelB="Has Results"
            onToggle={onToggle}
            defaultToggled={data?.has_results}
            disabled={true}
          />
        </Col>
        <Col xs="12" md="4" className="mb-4 mb-md-0">
          <Toggle
            id="published"
            labelA="Not Visible on Website"
            labelB="Visible on Website"
            onToggle={onToggle}
            defaultToggled={data?.published}
          />
        </Col>
        { onlyAttachment !== "true" && 
            <Col xs="12" md="4" className="mb-4 mb-md-0">
              <Toggle
                id="featured"
                // labelText="Visible"
                labelA="Not Featured on Home Page"
                labelB="Featured on Home Page"
                onToggle={onToggle}
                defaultToggled={data?.featured}
              />
            </Col>
        }
      </Row>
      <TrialIdModal
        open={idModalIsOpen}
        onClose={() => setIdModalIsOpen(false)}
        onConfirm={(val) => submit('org_study_id', val)}
        data={data}
      />
    </div>
  );
}

export default DetailOverview;

// TODO: save to formUtils?
const TextFieldStyled = styled.div`
	.bx--text-input:focus, .bx--text-input:active,
	.bx--text-area:focus, .bx--text-area:active {
			outline: none;
	}
`

const TrialIdColStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  button {
    color: #393939;
    font-size: 12px;
    width: 20px;
    padding: 0 10px;
    flex-grow: 0;
    width: fit-content;
    border-color: #8d8d8d;
    background-color: #d9d9d9;
    border-radius: 5px;
  }
`

const TrialIdFieldStyled = styled(TextFieldStyled)`
  flex-grow: 1;
`